<template>
  <div class="container" style="position:relative;">
    <div class="main-page">
      <page-header :headerConfig="headerConfig" @handleClickIocn="handleClickIocn" />

      <!-- <page-tops /> -->

      <div class="main-nav" style="position: absolute; bottom: 50px;">
        <div class="main-nav-item">
          <!-- 直接跳转 -->
          <!-- <router-link :to="{name:'signUp',params:{name:'SignUp'}}"> -->
          <div class="sub-item sign-up" @click.stop="jumpToSign">
            <div class="sub-tit-wrap" v-if="this.currentSignup.id">
              报名信息
              <span class="en">Register[{{ this.currentSignup.status }}]</span>
            </div>
            <div class="sub-tit-wrap" v-else>
              注册报名
              <!-- <span class="en">Register[{{ this.currentSignup.status }}]</span> -->
              <span class="en">Register[未报名]</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/signup.png" alt="" />
              <img class="icon" src="@/assets/img/signup-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->

          <!-- <router-link to="/paper"> -->
          <div @click.stop="jumpTo('paper')" class="sub-item send">
            <div class="sub-tit-wrap">
              论文投稿
              <span class="en">Submission of papers</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/send.png" alt="" />
              <img class="icon" src="@/assets/img/send-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
        </div>
        <div class="main-nav-item">
          <!-- <router-link to="/payPage"> -->
          <div @click.stop="jumpTo('pay')" class="sub-item pay">
            <div class="sub-tit-wrap">
              缴费管理
              <span class="en">Payment <br />
                management</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/pay.png" alt="" />
              <img class="icon" src="@/assets/img/pay-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
          <!-- <router-link to=""> -->
          <div @click.stop="jumpToConferOnline" class="sub-item hy">
            <div class="sub-tit-wrap">
              会议直播
              <span class="en">Live <br />
                conference</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/hy-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
          <!-- <router-link to="/visitPage"> -->
          <div @click.stop="jumpTo('visit')" class="sub-item bm">
            <div class="sub-tit-wrap">
              报名参观 <span class="en">Sign up</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/bm-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
          <!-- <router-link to=""> -->
          <div @click.stop="jumpToQuestionnaire" class="sub-item dc">
            <div class="sub-tit-wrap">
              调查问卷 <span class="en">Question</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/dc-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
        </div>
        <div class="main-nav-item">
          <!-- <router-link to="/meetPage"> -->
          <div @click.stop="jumpTo('meet')" class="sub-item msg">
            <div class="sub-tit-wrap">
              会议信息
              <span class="en">Meeting<br />information</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/msg.png" alt="" />
              <img class="icon" src="@/assets/img/msg-icon.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
          <!-- <router-link to="/signIn"> -->
          <div @click.stop="jumpTo('signIn')" class="sub-item qd">
            <div class="sub-tit-wrap">
              签到入场
              <span class="en">Check in for <br />
                admission</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/qd.png" alt="" />
            </div>
          </div>
          <!-- </router-link> -->
          <div @click.stop="jumpTo('loginOut')" v-if="signinShow" class="sub-item out">
            <div class="sub-tit-wrap">
              退出登录 <span class="en">Sign out</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/out.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('login')" v-if="!signinShow" class="sub-item out">
            <div class="sub-tit-wrap">登录 <span class="en">Sign In</span></div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/out.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pageHeader from "@/components/header"
  import pageTops from "./components/jumbotron.vue"
  import store from "@/store"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  export default {
    name: "HomePage",
    components: {
      pageHeader,
      pageTops,
    },
    mixins: [CurrentConferMixin, CurrentUserMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-cuowu",
          headerTitle: "中国土木工程学会",
          color: "#fff",
          bgColor: "#f9000d",
        },
      }
    },
    computed: {
      signinShow() {
        return this.$store.getters["auth/isTokenValid"]
      },
    },
    methods: {
      handleClickIocn() {
        window.close()
      },
      jumpTo(path) {
        if (path == "login") {
          this.$router.push({ name: path, params: { userId: "" } })
        } else if (path == "loginOut") {
          this.$store
            .dispatch("auth/logout")
            .then(this.$message("退出登录成功！"))
          //   this.signinShow = false
        } else if (path == "meet") {//不登录可以查看会议信息
          this.$router.push({ name: path, params: { userId: "" } })
        } else {
          if (this.$store.getters["auth/isTokenValid"]) {
            this.$router.push({ name: path, params: { userId: "" } })
          } else {
            this.$message("请先登录")
          }
        }
      },
      jumpToSign() {
        // 由于报名信息需要根据是否已注册跳转到不同页面，单独写个方法控制，
        // 不然click事件只绑定到文字标签，导致点击区域太小
        if (this.$store.getters["auth/isTokenValid"]) {
          if (this.currentSignup.id) {
            this.$router.push({ name: "info" })
          } else {
            this.$router.push({ name: "signUp" })
          }
        } else {
          this.$message("请先登录")
        }
      },
      jumpToQuestionnaire() {
        // 由于调查问卷要当天打开，所以就单独控制
        if (this.$store.getters["auth/isTokenValid"]) {
          let opendate = new Date(this.currentConference.conferencedate)
          opendate.setHours(0, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);
          if (today >= opendate) {
            window.open(this.currentConference.surveyurl)
          } else {
            this.$message("会议召开后才能填写")
          }
        } else {
          this.$message("请先登录")
        }
      },
      jumpToConferOnline() {
        // 不登录可以直接进入会议直播
        if (this.currentConference.liveurl) {
          window.open(this.currentConference.liveurl)
        } else {
          this.$message("尚未开始直播")
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main-page {
    width: 100%;
    height: calc(100vh - 44px);
    padding: 0 15px;
    background: url("~@/assets/img/main-page-bg.jpg") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    overflow: hidden;

    .main-nav {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .main-nav-item {
        border-radius: 3px;

        .sub-item {
          width: 100%;
          border-radius: 3px;
          background: #fff;
          box-sizing: border-box;
          box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
          overflow: hidden;

          .img-group {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            width: 100%;
            height: calc(100% - 57px);

            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0px;
              height: 30px;
              width: 100%;
              background: linear-gradient(to bottom,
                  rgba(255, 255, 255, 0.1),
                  rgba(254, 0, 0, 0.2));
            }

            .icon {
              position: absolute;
              bottom: 10px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }

          &.pay {
            height: 120px;

            .img {
              position: absolute;
              bottom: 0px;
              left: 0;
              width: 65px;
            }

            .icon {
              position: absolute;
              bottom: 10px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }

          &.out {
            height: 50px;
            margin-top: 10px;

            .img-group {
              height: calc(100% - 45px);
            }
          }

          &.msg {
            height: 190px;
          }

          &.qd {
            height: 70px;
            margin-top: 10px;

            .icon {
              position: absolute;
              bottom: 10px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }

          &.msg {
            .icon {
              position: absolute;
              top: -50px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }

          &.hy,
          &.bm,
          &.dc {
            height: 60px;
            margin-top: 10px;

            .icon {
              position: absolute;
              bottom: 2px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }

          &.bm,
          &.dc {
            .img-group {
              height: calc(100% - 45px);
            }
          }
        }

        .sub-tit-wrap {
          font-size: 14px;
          padding: 8px;

          .en {
            display: block;
            margin-top: 3px;
            color: #ccc;
            font-size: 12px;
          }
        }

        &:nth-child(1) {
          flex: 32%;

          .sub-item {
            &.sign-up {
              height: 120px;

              .img-group {
                height: calc(100% - 45px);

                .img {
                  position: absolute;
                  bottom: 0;
                  left: 8px;
                  width: 50px;
                }

                .icon {
                  position: absolute;
                  bottom: 10px;
                  right: 8px;
                  width: 25px;
                  height: 25px;
                }
              }
            }

            &.send {
              margin-top: 10px;
              height: 200px;

              .img {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 58px;
              }

              .icon {
                position: absolute;
                bottom: 10px;
                right: 8px;
                width: 25px;
                height: 25px;
              }
            }
          }
        }

        &:nth-child(2) {
          margin: 0 10px;
          flex: 32%;
        }

        &:nth-child(3) {
          flex: 36%;
        }
      }
    }
  }
</style>